<template>
  <v-container class="pa-0">
    <v-img :src="$vuetify.breakpoint.xsOnly ? `${publicPath}${sliderContent.mob_img_path}` : `${publicPath}${sliderContent.img_path}`">
      <v-container style="height: 100%;" :class="$vuetify.breakpoint.xsOnly ? 'px-6' : 'px-10'">
        <v-row style="height: 100%;" :align-content="$vuetify.breakpoint.xsOnly ? 'start' : 'center'" :justify="sliderContent.colAlign">
          <v-col cols="12" sm="6" align-self="center" :class="$vuetify.breakpoint.xsOnly ? 'my-5' : ''">
            <v-row :justify="sliderContent.colAlign">
              <div :class="`display-1 ${sliderContent.textAlign}`" style="width: 100%;" v-html="sliderContent.title"></div>
              <div :class="`title ${sliderContent.textAlign} font-weight-bold`" style="width: 100%;" v-html="sliderContent.subtitle"></div>
              <div :class="`mt-10 ${sliderContent.textAlign}`"
                   :style="$vuetify.breakpoint.smAndUp ? `max-width: 73%;` : ''"
                   v-html="actionType === 'cashback' ? sliderContent.descCashback : sliderContent.descVoucher"></div>
              <v-btn v-if="sliderContent.child.length > 0" color="primary" rounded large
                     @click="$router.push(`/${sliderContent.child[0].link_url}`)">
                {{ $t(`${sliderContent.child[0].title}`) }}
              </v-btn>
            </v-row>
          </v-col>
        </v-row>
      </v-container>
    </v-img>
  </v-container>
</template>

<script>
export default {
  name: 'PageHeaderImage',
  components: {
    //
  },
  props: {
    sliderContent: Object,
  },
  data() {
    return {
      //
    };
  },
  methods: {
    //
  },
  computed: {
    actionType() {
      return this.$route.meta.bbType;
    },
  },
};
</script>

<style scoped>

</style>
